export default __webpack_public_path__ + "static/media/house-5.ec2e5c33.jpg";